import axios from "axios";
const API_URL = "https://api.suuplink.suave.ppg.br/api/auth/";

const login = (username, password) => {
  const headers = {
  'Content-Type': 'application/json',
   "Access-Control-Allow-Origin": "true"
}

  return axios
    .post(API_URL + "signin", {
      username,
      password,
    }, {
      headers:  headers
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("admin", JSON.stringify(response.data));
      }
      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("admin");
};

const getCurrentAdmin = () => {
  console.log(JSON.parse(localStorage.getItem("admin")));
  return JSON.parse(localStorage.getItem("admin"));
};

const AuthService = {
  login,
  logout,
  getCurrentAdmin,
};

export default AuthService;
